import { useQuery } from "@tanstack/react-query";

import { TTrackReadBody } from "../../models";
import { getEntries } from "../../services/track";

export type TEntrie = {
    Activity: {
        ActivitySection: {
            name: string;
        };
        authorName: string;
        id_e: string;
        name: string;
    };
    Project: {
        Client: {
            name: string;
        };
        color: string;
        id_e: string;
        name: string;
    };
    description: string;
    end_at: string;
    id_e: string;
    locked: boolean;
    project_id: string;
    sector_id: string;
    start_at: string;
    start_date: string;
    time_report_id: string;
    total_time: number;
    user_id: string;
};

type TResponseReadEntries = {
    entries: TEntrie[];

    time_requested: {
        [key: string]: number;
    };
    total_entries: number;
    total_pages: number;
    user_projects: string[];
    user_projects_with_entries: {
        id_e: string;
        name: string;
    }[];
};

export function useReadEntries({
    all,
    clientId,
    endDate,
    length,
    page,
    projectId,
    reportId,
    responseFormat,
    searchTerm,
    startDate,
    userId,
}: TTrackReadBody) {
    return useQuery<TResponseReadEntries, unknown, TResponseReadEntries>({
        enabled: true,
        queryKey: [`getEntries`],
        queryFn: () =>
            getEntries({
                all,
                clientId,
                endDate,
                length,
                page,
                projectId,
                reportId,
                responseFormat,
                searchTerm,
                startDate,
                userId,
            }),
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
    });
}
